import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Breadcrumbs from '../../layout/Breadcrumbs';
import Contact from '../contact/Contact';
import HappyClients from '../happyclients/HappyClients';

const Gallery = ({ showBreadcrumbs = true }) => {
  const images = [
    {
      url: './assets/images/culture/lohri_celebration_team.jpg',
      title: 'Lohri Celebration'
    },
    {
      url: './assets/images/culture/lohri_celebration.jpg',
      title: 'Lohri Celebration'
    },
    {
      url: './assets/images/culture/appreciation_employees_gift.jpg',
      title: 'Appreciation Employees Gifts'
     },
    // {
    //   url: './assets/images/culture/client_generosity.jpg',
    //   title: 'Client Generosity'
    // },
    {
      url: './assets/images/culture/special_gift-from_sam_to_mahesh.jpg',
      title: 'A Special Gift from Sam to Mahesh Sharma'
    },
    {
      url: './assets/images/culture/special_gift-from_sam_to_joshi.jpg',
      title: 'A Special Gift from Sam to Amit Joshi'
    },
    {
      url: './assets/images/culture/special_gift-from_sam_to_kapil.jpg',
      title: 'A Special Gift from Sam to Kapil Durgapal'
    },
    {
      url: './assets/images/culture/diwali_celebration.jpg',
      title: 'Diwali Pooja'
    },
    {
      url: './assets/images/culture/employee_diwali.jpg',
      title: 'Diwali Gifts'
    },
    {
      url: './assets/images/culture/rangoli_celebration.jpg',
       title: 'Rangoli Celebration'
    },
    {
      url: './assets/images/culture/spadez_company.jpg',
      title: 'Spadez Company'
    },
    // {
    //   url: './assets/images/culture/spadez-team.jpg',
    //    title: 'Spadez Company'
    //   },
    // {
    //   url: './assets/images/culture/spadez-group.jpg',
    //    title: 'Spadez Company'
    // },
   {
        url: './assets/images/culture/hr_birthday.jpg',
        title: 'Spadez Team Birthday Celebration'
    },
    {
      url: './assets/images/culture/spadez_trip.jpg',
      title: 'Spadez Trip'
    },
    {
        url: './assets/images/culture/ram-mandir-ayodhya-celebration.jpg',
        title: 'Ram Mandir Ayodhya Celebration'
    },
    {
        url: './assets/images/culture/ram-mandir-ayodhya-celebrationv2.jpg',
        title: 'Ram Mandir Ayodhya Celebration'
    },
    {
        url: './assets/images/culture/team_funtime.jpg',
        title: 'Spadez Team Fun Time'
    }
    
  ];

  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 100,
      once: true,
    });
  }, []);

  return (
    <>
      {showBreadcrumbs && (
        <Breadcrumbs
          pageTitle="Company Gallery"
          pageSubtitle={<><strong>Explore Our Work</strong>: A Visual Showcase of Our Projects & Achievements.</>}
          activePage="Company Gallery"
        />
      )}

      <section id="gallery" className="gallery">
        <div className="container mx-auto px-4">
          <div className="gallery-slider" data-aos="fade-up">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={1}
              spaceBetween={30}
              navigation={true}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
              }}
              className="gallery-swiper"
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <div 
                    className="relative group overflow-hidden rounded-lg"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <img
                      src={image.url}
                      alt={image.title}
                      className="img-fluid"
                    //   className="w-full h-[300px] object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                    <div className="absolute bottom-10 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                      <small className="text-sm font-semibold text-uppercase">{image.title}</small>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      <HappyClients/>
      <Contact/>
    </>
  );
};

export default Gallery;